import React, { useEffect, useRef, useState, useContext } from 'react'

import styled from 'styled-components'
import { useDrop } from 'react-dnd'
import toast from 'react-hot-toast'
import { FiPlus } from 'react-icons/fi'

import DraggableItem from './DraggableItem'
import RemovableItem from './RemovableItem'
import KeywordSearcher from './KeywordSearcher'

import { DnDInputContext } from '../context/DnDInputContext'

const Dropzone = ({
  values,
  noClick,
  className = '',
  errorMessage = '',
  onChange,
  title = '',
  heading = '',
}) => {
  const [enableSearcher, setEnableSearcher] = useState(false)

  const btnRef = useRef(null)

  const { options, setOptions, setKeywordItems } = useContext(DnDInputContext)

  const updateItems = (item, status) => {
    const updatedOptions = options.map((option) =>
      option.id === item.id ? { ...option, status } : { ...option }
    )

    setOptions(updatedOptions)
    setKeywordItems(updatedOptions)

    onChange && onChange(updatedOptions)
  }

  const handleDrop = (item, monitor) => {
    const didDrop = monitor.didDrop()

    const movedOptions = options.filter((option) => option.status === 'moved')

    if (didDrop || movedOptions.length >= 3) {
      toast.error('Professional Headline should not be more than 3')

      return
    }

    updateItems(item, 'moved')
  }

  const handleClick = (item) => {
    const movedOptions = options.filter((option) => option.status === 'moved')

    if (movedOptions.length >= 3) {
      toast.error('Professional Headline should not be more than 3')

      return
    }

    updateItems(item, 'moved')
  }

  const handleCollect = (monitor) => ({
    isOver: !!monitor.isOver(),
  })

  const handleDelete = (id) => {
    updateItems({ id }, 'current')
  }

  const handleExpandButtonClick = () => {
    setEnableSearcher(!enableSearcher)
    setKeywordItems(options)
  }

  useEffect(() => {
    setOptions(values)
  }, [])

  const [{ isOver }, drop] = useDrop({
    accept: 'card',
    drop: handleDrop,
    collect: handleCollect,
  })

  return (
    <DropzoneContainer>
      <DropzoneLabel
        className={errorMessage && 'has-error'}
        htmlFor="firstName"
      >
        {title} <span style={{ color: 'red' }}>*</span>
      </DropzoneLabel>
      <DropzoneHeader>
        <p>{heading}</p>
        {!noClick && (
          <ExpandButton
            ref={btnRef}
            onClick={handleExpandButtonClick}
            className="keywordBtn"
          >
            Select Items
            <span>
              <FiPlus className="icon" />
            </span>
          </ExpandButton>
        )}
      </DropzoneHeader>

      <DropzoneItemPicker
        ref={drop}
        style={{
          background: isOver ? '#f5f5f5' : '#fff',
          border: isOver ? '1px solid #ccc' : '',
          flexWrap: 'wrap',
          borderColor: className.includes('has-error') ? 'red' : '#ccc',
        }}
      >
        {options
          .filter((item) => item.status === 'moved')
          .map((e, index) => (
            <>
              <DraggableItem
                key={index}
                index={index}
                id={e.id}
                onDelete={handleDelete}
                handleClick={() => null}
                item={e}
              />
              <RemovableItem
                noClose={false}
                key={e.item.id}
                item={e}
                id={e.item.id}
                handleDelete={handleDelete}
                onChange={onChange}
              />
            </>
          ))}
      </DropzoneItemPicker>

      {enableSearcher && (
        <KeywordSearcher onChange={onChange} handleClick={handleClick} />
      )}

      {className.includes('has-error') && (
        <sub style={{ color: 'red', margin: 0 }}>{errorMessage}</sub>
      )}
    </DropzoneContainer>
  )
}

const DropzoneItemPicker = styled.div`
  position: relative;
  width: 100%;
  min-height: 60px;
  border: 1px solid #aeb3c9;
  border-radius: 3px;
  padding: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  padding-bottom: 0.375rem;

  &.has-error {
    border-color: red;
  }

  @media (max-width: 768px) {
    left: 0px;
    top: 102%;
    width: 100%;
    max-width: 100%;
  }
`

const DropzoneContainer = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`

const DropzoneLabel = styled.label`
  font-size: 0.7rem;
  font-weight: 300;
  color: rgb(14, 19, 36);
  margin-bottom: 0.7rem;
  line-height: 1.7;
  font-weight: 600;
  margin-bottom: 0.25rem;

  &.has-error {
    color: red;
  }
`

const DropzoneHeader = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;

  p {
    font-size: 0.7rem;
    font-weight: 300;
    color: rgb(49, 55, 79);
  }
`

const ExpandButton = styled.button`
  background: none;
  outline: none;
  border: none;
  font-size: 0.7rem;
  font-weight: 500;
  color: #858aa0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  &:hover {
    color: #31374f;
  }
`

export default Dropzone
